/** Formatting the kit and both boards share. Dates are calendar dates as the source wrote them (UTC), never shifted. */
import type { BoardTabDef, TabSource } from './types';

const DAY = new Intl.DateTimeFormat('en-US', { timeZone: 'UTC', month: 'short', day: 'numeric', year: 'numeric' });
const STAMP = new Intl.DateTimeFormat('en-US', { timeZone: 'America/New_York', month: 'short', day: 'numeric', hour: 'numeric', minute: '2-digit' });
const USD = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 });

/** "Oct 4, 2026" from a YYYY-MM-DD (or ISO) string; null when there is no date. */
export function boardDate(value: string | null | undefined): string | null {
  if (!value) return null;
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (!m) return null;
  return DAY.format(new Date(Date.UTC(Number(m[1]), Number(m[2]) - 1, Number(m[3]))));
}

/** A moment, in New York time, for "as of" lines. */
export function boardStamp(value: string | null | undefined): string | null {
  if (!value) return null;
  const d = new Date(value);
  return Number.isNaN(d.getTime()) ? null : `${STAMP.format(d)} ET`;
}

export function boardMoney(value: number | null | undefined): string | null {
  if (value === null || value === undefined || Number.isNaN(Number(value))) return null;
  return USD.format(Number(value));
}

const SOURCE_TEXT: Record<TabSource, string> = { STATUS: 'Monday status word', GROUP: 'Monday group', EMERGE: 'eMerge lens, not a board view' };

/** What a tab is, said in words: the source, and for a group the mirror run it was read from. */
export function tabSourceText(tab: Pick<BoardTabDef, 'source' | 'as_of'> & { key?: string; source_text?: string | null }): string {
  if (tab.source_text) return tab.source_text;
  if (tab.key === 'all') return 'Every row of the board';
  if (tab.source === 'GROUP') {
    const at = boardStamp(tab.as_of);
    return at ? `Monday group (as of ${at})` : 'Monday group';
  }
  return SOURCE_TEXT[tab.source];
}
